import { render, staticRenderFns } from "./ButtonOnboarding.vue?vue&type=template&id=63bd6460&scoped=true&"
import script from "./ButtonOnboarding.vue?vue&type=script&lang=js&"
export * from "./ButtonOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./ButtonOnboarding.vue?vue&type=style&index=0&id=63bd6460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd6460",
  null
  
)

export default component.exports